import styled,{keyframes} from "styled-components";
import React, { useEffect, useState } from "react";
import { stripMarkdownAndHtml } from "utilities/stripMarkdown";


const FactorRow = ({ data, isExpanded, summary, min, max, verticalTitles, findByOptionName }) => {
    const [selectedRow, setSelectedRow] = useState(null);
    const [questionData, setQuestionData] = useState([]);


    const getFactorScore = (item) => {
        if (!item || !item.culture_scores || !item.culture_scores.factor_scores) {
            return null;
        }
        const factorData = Object.values(item.culture_scores.factor_scores).find(i=>i.factor == summary.name);
        const rawScore = factorData?.scores;
        return rawScore !== null && rawScore !== undefined ? rawScore.toFixed(1) : null;
    };

    const formatScoreDisplay = (score) => {
        if (score === null || score === undefined || isNaN(score) || score === 'NaN' || score === '') {
          return '-';
        }
        return score;
    };

    const getColorGrade = (score) => {
        if (
            score === null ||
            score === undefined ||
            isNaN(score) ||
            score === "" ||
            score === "NaN"
        ) {
            return "#fff";
        }

        // Convert score to number if it's a string
        const numericScore = typeof score === "string" ? parseFloat(score) : score;

        // Double check after conversion
        if (isNaN(numericScore)) {
            return "#fff";
        }

        // Discrete color ranges - Red: 0-4.9, Yellow: 5-6.9, Green: 7-10
        if (numericScore >= 0 && numericScore < 5) {
            return "#dd524c"; // Red
        } else if (numericScore >= 5 && numericScore < 7) {
            return "#f5d565"; // Yellow
        } else if (numericScore >= 7 && numericScore <= 10) {
            return "#10B981"; // Green
        }

        return "#fff";
    }

    const getTextColor = (score) => {
        // Yellow text should use #6f391a
        if (
            score === null ||
            score === undefined ||
            isNaN(score) ||
            score === "" ||
            score === "NaN"
        ) {
            return "#000";
        }

        const numericScore = typeof score === "string" ? parseFloat(score) : score;

        if (isNaN(numericScore)) {
            return "#000";
        }

        // Yellow cells (5-6.9) should have #6f391a text color
        if (numericScore >= 5 && numericScore < 7) {
            return "#6f391a";
        }

        return "#fff";
    }


      useEffect(()=>{
            if(data){
                let questions = Object.values(data[0].culture_scores.item_scores).filter(i=>i.factor_name == summary.name)
                setQuestionData(questions)
            }
      },[data, summary])


      const get_item_scores = (question) => {
        let total_responses = 0 
        let total_scores = data.map((item)=>{
            let score = Object.values(item.culture_scores.item_scores).find(i=>i.question == question).scores
            let responses = item.responses

            if(!score){
                return 0
            }
            total_responses += responses
            return score*responses
        }).reduce((a,b)=>a+b,0)


          return total_responses > 0 ? (total_scores / total_responses).toFixed(1) : null;
      }

    return (

        <>
        <TableRow2 selected={isExpanded} onClick={()=>setSelectedRow(!selectedRow)}>
            {
            isExpanded && (
                <>
                <FirstColumnCell2>
                  {summary.name}
                  <CaretIcon isExpanded={selectedRow} />
                </FirstColumnCell2>
                            <TableCell color={getColorGrade(summary.scores !== null && summary.scores !== undefined ? summary.scores.toFixed(1) : null)} textColor={getTextColor(summary.scores !== null && summary.scores !== undefined ? summary.scores.toFixed(1) : null)}>{formatScoreDisplay(summary.scores !== null && summary.scores !== undefined ? summary.scores.toFixed(1) : null)}</TableCell>
                            {verticalTitles.map((title) => {
                                const item = findByOptionName(title);
                                if (!item) {
                                    return (
                                        <TableCell
                                            key={title}
                                            color="#fff"
                                            textColor="#000"
                                        >
                                            -
                                        </TableCell>
                                    );
                                }
                                const meetsThreshold = item?.meetsThreshold !== false; // Default to true if not set

                                if (!meetsThreshold) {
                                    return (
                                        <TableCell
                                            key={title}
                                            color="#fff"
                                            textColor="#000"
                                        >
                                            -
                                        </TableCell>
                                    );
                                }

                                return (
                                    <TableCell
                                        key={title}
                                        color={getColorGrade(getFactorScore(item))}
                                        textColor={getTextColor(getFactorScore(item))}
                                    >
                                        {formatScoreDisplay(getFactorScore(item))}
                                    </TableCell>
                                );
                            })}
                </>
            )
            }
            
        </TableRow2>

        {selectedRow && isExpanded && (
                <>
                {questionData.map((question, idx) => {
                    const overall_score = get_item_scores(question.question);

                   return (
                    <TableRow2 key={question.question || idx} selected={selectedRow}>
                        <FirstColumnCell3>{stripMarkdownAndHtml(question.question)}</FirstColumnCell3>
                           <TableCell color={getColorGrade(overall_score)} textColor={getTextColor(overall_score)}>{formatScoreDisplay(overall_score)}</TableCell>
                        
                           {verticalTitles.map((title) => {
                               const item = findByOptionName(title);
                               if (!item) {
                                   return (
                                       <TableCell
                                           key={`${title}-${question.question}`}
                                           color="#fff"
                                           textColor="#000"
                                       >
                                           -
                                       </TableCell>
                                   );
                               }
                               const meetsThreshold = item?.meetsThreshold !== false; // Default to true if not set

                               if (!meetsThreshold) {
                                   return (
                                       <TableCell
                                           key={`${title}-${question.question}`}
                                           color="#fff"
                                           textColor="#000"
                                       >
                                           -
                                       </TableCell>
                                   );
                               }

                               let rawScore = Object.values(item?.culture_scores?.item_scores || {}).find(i => i.question == question.question)?.scores;
                            let score = rawScore !== null && rawScore !== undefined ? rawScore.toFixed(1) : null;
                            return (
                                <TableCell
                                    key={`${title}-${question.question}`}
                                    color={getColorGrade(score)}
                                    textColor={getTextColor(score)}
                                >
                                    {formatScoreDisplay(score)}
                                </TableCell>
                            );
                        })}
                    </TableRow2>
                )}  
                )}


                </>

        )}

        </>
    )

}

export default FactorRow;

const CaretIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-left: 8px;
  color: #000;
  font-size: 12px;
  
  &::before {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    transition: transform 0.2s ease;
    
    ${props => props.isExpanded ? `
      border-width: 6px 5px 0 5px;
      border-color: currentColor transparent transparent transparent;
    ` : `
      border-width: 5px 0 5px 6px;
      border-color: transparent transparent transparent currentColor;
    `}
  }
`;

const TableRow2 = styled.tr`
    max-height:${props=>props.selected ? '200px' : '0px'};
    height: ${props=>props.selected ? '35px' : '0px'};
    overflow:hidden;
    transition:all 0.8s;
`;



const TableCell = styled.td`
  border: 1px solid #ddd;
  padding: 0;
  text-align: center;
  width: 50px;
  height:100%;
  font-weight: 500;

  background-color: ${props => props.color ? props.color : '#fff'};
  color: ${props => props.textColor || '#000'};

`;


const FirstColumnCell2 = styled.td`
  border: 1px solid #ddd;
  padding: 0 16px;
  text-align: left;
  width: 350px; /* Wider first column */
  min-width: 350px;
  height: 100%;
  background-color: #fff;
  color: #2D70E2;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  position: sticky;
  left: 0;
  z-index: 1;
`;

const FirstColumnCell3 = styled.td`
  border: 1px solid #ddd;
  padding: 5px 24px;
  text-align: left;
  width: 350px; /* Wider first column */
  min-width: 350px;
  height: 100%;
  background-color: #fff;
  color: #2A3039;
  font-size: 12px;
  cursor: pointer;
  position: sticky;
  left: 0;
  z-index: 1;
`;


const QuestionData = [
    {
        question: 'We help and support one another through emotional hardships (e.g. tough times).We help and support one another through emotional hardships (e.g. tough times).',
        overall: 76,
        customerService: 4,
        sales: -3,
        marketing: -6,
        operations: -16,
    },
    {
        question: 'How do you feel about the customer service?',
        overall: 77,
        customerService: 5,
        sales: -2,
        marketing: -5,
        operations: -15,
    },
    {
        question: 'How do you feel about the sales team?',
        overall: 78,
        customerService: 6,
        sales: -1,
        marketing: -4,
        operations: -14,
    }
]